<video controls [src]="source()" width="800" height="600">
    Your browser does not support the video tag.
</video>